import React from "react";
import { Check, FileText, X } from "lucide-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { CopyButton, SectionHeader } from "./Primitives";
import { useLocale } from "../lib/i18n";

export default function InstructionView({ sample }) {
  const { t } = useLocale();
  return (
    <div className="split-view">
      <section className="document-pane panel">
        <SectionHeader
          eyebrow={t("instruction.prompt")}
          title="instruction.md"
          aside={<CopyButton value={sample.instruction} label={t("instruction.copy")} />}
        />
        <div className="markdown-body">
          {sample.instruction ? (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{sample.instruction}</ReactMarkdown>
          ) : (
            <div className="missing-panel">{t("instruction.missing")}</div>
          )}
        </div>
      </section>
      <aside className="contract-pane">
        <div className="sticky-panel panel">
          <SectionHeader eyebrow={t("instruction.pathEyebrow")} title={t("instruction.pathTitle")} />
          <div className="contract-list">
            {sample.analysis.instructionContract.map((item) => (
              <div className={item.passed ? "contract-pass" : "contract-fail"} key={item.marker}>
                {item.passed ? <Check size={15} /> : <X size={15} />}
                <div><strong>{item.marker}</strong><span>{item.label}</span></div>
              </div>
            ))}
          </div>
          <div className="contract-note">
            <FileText size={15} />
            <p>{t("instruction.note")}</p>
          </div>
        </div>
      </aside>
    </div>
  );
}
